
import React from 'react'
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";
import {Image} from 'antd';

import { VEH_IMAGE_URL } from '../Api/constants';
import appColors from '../config/appColors';
import { Link } from 'react-router-dom';

const VehicleView = (props) => {

    const item = props?.vehicle;

    return (
        <div
            style={{
                display: 'flex',
                flex: '0 0 15%', // Allow flex items to grow and shrink, with an initial width of 30%
                margin: '5px', // Add margin for spacing
                height: '180px',
                backgroundColor: '#D4D4D4',
                borderRadius: '10px',
                flexDirection: 'column',
            }}
        >

            <div style={{ justifyContent: 'center', display: 'flex', width: "100%", height: "50%" }}>
                <Image
                    // width={100}
                    // height={100}
                    // key={index}
                    src={VEH_IMAGE_URL + item?.images[0]} alt="vehicle"
                    // alt={`Vehicle ${index + 1}`}
                    style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: '100%', }}
                />
                {/* <img
                    src={VEH_IMAGE_URL + item?.images[0]} alt="vehicle"
                    style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: '100%', }}
                /> */}
            </div>
            <div style={{ padding: '10px', }}>
                <Typography sx={vehLabel} >
                    {item?.veh_name} ({item?.reg_no})
                </Typography>


                <Link
                    style={{
                        display: 'flex', borderColor: appColors.primary, borderWidth: 2, borderRadius: '5px',
                        marginTop: '5px', alignItems: 'center', justifyContent: 'center', display: 'flex',
                        width: "70%", height: 20, backgroundColor: 'white', textDecoration: 'none', borderBottom: 'none'
                    }}
                    to={{ pathname: `/vehicle-details/${item?.veh_id}`, state: { data: 'item' } }}>
                    <Typography sx={{ fontSize: 10, fontFamily: 'Poppins', color: appColors.black, }}>View Details</Typography>
                </Link>


            </div>
        </div>
    )
}


const vehLabel = {
    fontSize: 12,
    color: appColors.black,
    fontFamily: 'Poppins',
    marginTop: 2,
    height: "35px",


}

export default VehicleView